import * as React from 'react';
import '../table/table.less';

// import WithCoreProps from '../../../hocs/withCoreProps';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { SecondaryRow, DynamicRow } from './tableRowModules';
import { InputsRow, InputsRowChangeState } from './tableRowModules';
import { SubRow } from './tableRowModules/subRow';
import { TotalsRow } from './tableRowModules/totalsRow';
import { TableColumn, Total, ColType } from '../table/types';
import { TableRowAppearances } from './types';
import { WithoutHeaderRow } from './tableRowModules/withoutHeader';
import { WithAccordionRow } from './tableRowModules/withAccordion';
import { WithCoreProps } from 'ff-shared-components-core';
import { WithAccordionGreyRow } from './tableRowModules/withAccordionGreyRow';
import { WithAccordionGreySubRow } from './tableRowModules/withAccordionGreySubRow';
import { WithAccordionGreyFooterRow } from './tableRowModules/withAccordionGreyFooterRow';

export interface PrefixImage {
	value?: string;
}

export interface TableRowProps {
	/**Set a row to be used on details click */
	row?: any;
	/**Set a row id to be used on details click */
	rowId: string;
	/**Sets an image  prefix for the row */
	rowImage?: string;
	/**sets an array of widths to render the table */
	columnsWidth?: ColType[];
	/**Set the row appearance */
	appearance: TableRowAppearances;
	/**Set the row columns  */
	columns?: TableColumn[];
	/**Set a checkbox(prefix) */
	withCheckbox?: boolean;
	/**Set an image(prefix) */
	withImage?: boolean;
	/**Set an image(prefix) */
	mobileImage?: string;
	/**Set a suffix to the row */
	withSuffix?: boolean;
	/**Sets a empty column at the end of table*/
	withEmptySpaceSuffix?: boolean;
	/**Sets a icon column at the end of table*/
	withDownloadableSuffix?: boolean;
	/**Set a pathToRedirect on details image click */
	pathToRedirect?: string;
	/**Sets if the checkbox is checked or not */
	isChecked?: boolean;
	/**Set headers to create sub-rows responsive appearance */
	headers?: string[];
	/**Set totals*/
	totals?: Total[];
	/* Sets the text of column of type bold*/
	isBold?: boolean;
	/**sets the state of the row selection */
	isSelected?: boolean;
	/**Sets an accordion button */
	withAccordionButton?: boolean;
	/**Set if the accordion is collapsed or not */
	isCollapsed?: boolean;
	/**Set if the row is green or not */
	isGreen?: boolean;
	/**Sets an icon of download on the end of the table */
	isDownloadable?: boolean;
	/**Sets a suffix name to be shown on mobile */
	suffixName?: string;
	/**Set an event to be handled when the checkbox is clicked */
	onClick?: (e?: any) => void;
	/**Sets an event to be handled on details click */
	onDetailsClick?: (row?: any) => void;
	/**Sets an event to be handled on row state change */
	handleRowChange?: (rowState: InputsRowChangeState) => void;
}

type Props = TableRowProps & RouteComponentProps;

class TableRowComponent extends React.PureComponent<Props> {
	render(): React.ReactNode {
		const { appearance } = this.props;
		return (
			<>
				{/* Primary Table use the bellow rows: */}
				{appearance === TableRowAppearances.dynamic && <DynamicRow {...this.props}></DynamicRow>}

				{/* WithoutHeader Table use the bellow rows: */}
				{appearance === TableRowAppearances.withoutHeader && (
					<WithoutHeaderRow {...this.props}></WithoutHeaderRow>
				)}

				{/* WithAccordion Table use the bellow rows: */}
				{appearance === TableRowAppearances.withAccordion && (
					<WithAccordionRow {...this.props}></WithAccordionRow>
				)}

				{/* WithAccordionGrey Table use the bellow rows: */}
				{appearance === TableRowAppearances.withAccordionGrey && (
					<WithAccordionGreyRow {...this.props}></WithAccordionGreyRow>
				)}

				{appearance === TableRowAppearances.withAccordionGreySubRow && (
					<WithAccordionGreySubRow {...this.props}></WithAccordionGreySubRow>
				)}

				{appearance === TableRowAppearances.withAccordionGreyFooterRow && (
					<WithAccordionGreyFooterRow {...this.props}></WithAccordionGreyFooterRow>
				)}

				{/* With Totals Tables use the bellow rows: */}
				{appearance === TableRowAppearances.secondary && <SecondaryRow {...this.props}></SecondaryRow>}

				{appearance === TableRowAppearances.subRow && <SubRow {...this.props}></SubRow>}

				{appearance === TableRowAppearances.totals && <TotalsRow {...this.props}></TotalsRow>}
				{/* With Totals Tables use the top rows: */}

				{/* WithInputs row */}
				{appearance === TableRowAppearances.inputsRow && <InputsRow {...this.props}></InputsRow>}
			</>
		);
	}
}

export const TableRow = WithCoreProps<TableRowProps>(withRouter(TableRowComponent));
